import { atom } from 'recoil';

export const lastedSendMsgId = atom({
    key: 'lastedSendMsgId',
    default: ''
})
